import { Directive, ElementRef, AfterViewChecked, OnDestroy, inject, input, output } from '@angular/core';
import { fromEvent, ReplaySubject, takeUntil } from 'rxjs';

@Directive({
  selector: '[speakingParticipantsHeight]',
  standalone: false,
})
export class PresentationSpeakersDirective implements AfterViewChecked, OnDestroy {
  private el = inject(ElementRef);

  // class name to match height
  public readonly bubbleSizePx = input(130);
  public readonly isMobile = input(false);
  public readonly newArraySize = output<number>();
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.matchHeight(this.el.nativeElement);
      });
  }

  public ngAfterViewChecked() {
    // call our matchHeight function here later
    this.matchHeight(this.el.nativeElement);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public matchHeight(parent: HTMLElement) {
    const containerSize = this.isMobile()
      ? parent.getBoundingClientRect().width
      : parent.getBoundingClientRect().height;
    const listSizeToShow = Math.round(containerSize / this.bubbleSizePx());
    this.newArraySize.emit(listSizeToShow || 1);
  }
}
